import { cn } from '@/lib/utils';
import { PCMP_CHANNEL_LABELS } from '../../constants/pcmpProposal.constants';
import { PCMP_CHANNELS, type PcmpChannel } from '../../types/pcmpProposal.types';
import { PcmpProposalSection } from './PcmpProposalSection';

interface PcmpPaymentSourceCardProps {
  paymentSource: PcmpChannel;
  canChange: boolean;
  blockedReason: string | null;
  onChangeRequest?: (target: PcmpChannel) => void;
}

/** Two-option pill switch (legacy Accounts Payment / Marketing Payment). */
export function PcmpPaymentSourceCard({
  paymentSource,
  canChange,
  blockedReason,
  onChangeRequest,
}: PcmpPaymentSourceCardProps) {
  const isInteractive = canChange && onChangeRequest !== undefined;
  return (
    <PcmpProposalSection title="Payment Source">
      <div
        role="radiogroup"
        aria-label="Payment source"
        className="inline-flex w-fit rounded-full border bg-muted/40 p-1"
      >
        {PCMP_CHANNELS.map((channel) => {
          const isActive = channel === paymentSource;
          return (
            <button
              key={channel}
              type="button"
              role="radio"
              aria-checked={isActive}
              disabled={!isInteractive || isActive}
              onClick={() => onChangeRequest?.(channel)}
              className={cn(
                'rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground enabled:hover:bg-muted enabled:hover:text-foreground',
                'disabled:cursor-default',
              )}
            >
              {PCMP_CHANNEL_LABELS[channel]} Payment
            </button>
          );
        })}
      </div>
      {!canChange && blockedReason ? (
        <p className="text-sm text-muted-foreground">{blockedReason}</p>
      ) : null}
    </PcmpProposalSection>
  );
}
